import firebase from 'firebase/app';
import { auth } from 'core/firebase';
import { dispatch } from '../store';
import { INIT_AUTH, SIGN_IN_ERROR, SIGN_OUT_SUCCESS, ADMIN_STATUS_CHANGE } from './constants';
import db from 'db';

export function initAuth() {
  let isResloved = false;
  return new Promise((resolve, reject) => {
    auth.onAuthStateChanged(
      async user => {
        window.user = user;
        if (!user) db.unwatchAll();
        if (user) {
          updateAdminStatus(user);

          const userDoc = db.users.get(user.uid);
          const userDocData = (await userDoc.load()) || {};

          user.lastSeen = userDocData.seen || Date.now();
          userDoc.set({
            seen: Date.now(),
            email: user.email,
            photoURL: user.photoURL,
            displayName: user.displayName
          });
        }
        dispatch(INIT_AUTH, user);
        if (!isResloved) {
          isResloved = true;
          resolve(user);
        }
      },
      error => reject(error)
    );
  });
}

function authenticate(provider): Promise {
  return auth.signInWithPopup(provider).then(signInSuccess);
}

async function updateAdminStatus(user) {
  if (user) {
    const doc = db.admins.get(user.uid);
    await doc.load();
    dispatch(ADMIN_STATUS_CHANGE, doc.exists());
  }
}

export function updateUserPhoto(photoURL: String) {
  return updateUser({ photoURL });
}

export function updateUserDisplayName(displayName: String) {
  return updateUser({ displayName });
}

async function updateUser(user: Object) {
  await db.users.get(auth.currentUser.uid).update(user);
  await auth.currentUser.updateProfile(user);
  dispatch(INIT_AUTH, auth.currentUser);
}

window.changeMyEmail = async email => {
  await auth.currentUser.updateEmail(email);
};

export function signInError(error) {
  dispatch(SIGN_IN_ERROR, error);
}

export function signInSuccess({ user }) {
  // updateUserSessionDate(user);
  // dispatch(SIGN_IN_SUCCESS, user);
}

export function resetPassword(email) {
  return auth.sendPasswordResetEmail(email);
}

export function signUpEmail(email, password): Promise<void> {
  return auth.createUserWithEmailAndPassword(email, password);
}

export function signInEmail(email, password): Promise<void> {
  return auth.signInWithEmailAndPassword(email, password);
}

export function signInWithGithub(): Promise {
  return authenticate(new firebase.auth.GithubAuthProvider());
}

export function signInWithGoogle(): Promise {
  return authenticate(new firebase.auth.GoogleAuthProvider());
}

export function signInWithTwitter(): Promise {
  return authenticate(new firebase.auth.TwitterAuthProvider());
}

export function signInWithFacebook(): Promise {
  return authenticate(new firebase.auth.FacebookAuthProvider());
}

export function signOut() {
  auth.signOut().then(signOutSuccess);
}

export function signOutSuccess() {
  dispatch(SIGN_OUT_SUCCESS);
}
